<script>
	import { searchCache } from './js/searchFunctions';

	export let searchOptions;

	function toggleFloaty(status) {
		// Grab our infobox section
		const infoboxes = document.getElementById('infoboxes');

		// If the page is not yet loaded, return
		if (!infoboxes) return;

		// If the switch is toggled, make floaty
		if (status) {
			infoboxes.style.position = 'fixed';
			infoboxes.style.marginLeft = '40%';
			infoboxes.style.top = '10em';
			infoboxes.style.left = 0;
			infoboxes.style.right = 0;
			infoboxes.style.height = '100px';
		} else {
			infoboxes.style.position = null;
			infoboxes.style.marginLeft = null;
			infoboxes.style.top = null;
			infoboxes.style.left = null;
			infoboxes.style.right = null;
			infoboxes.style.height = null;
		}
	}

	$: searchOptions.floatyBoxes, toggleFloaty(searchOptions.floatyBoxes);
</script>

<div id="searchForm">
	<form>
		<input id="search" type="search" placeholder="item search (name/id)" bind:value={searchOptions.search} on:input={searchCache(searchOptions)}/><br />
		<select id="search_type" bind:value={searchOptions.searchType}>
			<option value="items">items</option>
			<option value="achievements">achievements</option>
			<option value="homestead">homestead</option>
			<option value="skills">skills</option>
			<option value="traits">traits</option>
		</select>
		<select id="max_entries" bind:value={searchOptions.maxEntries}>
			<option value=50 >50</option>
			<option value=100>100</option>
			<option value=150>150</option>
			<option value=200>200</option>
			<option value=250>250</option>
			<option value=300>300</option>
			<option value=500>500</option>
			<option value=1000>1000</option>
		</select>
		<br/>
		<input id="Floaty" type="checkbox" bind:checked={searchOptions.floatyBoxes}/> Have floaty boxes?
		<input id="mediawiki" type="checkbox" bind:checked={searchOptions.mediawikiSearch}/> Use Mediawiki query?
		<input id="useHardstuck" type="checkbox" bind:checked={searchOptions.hardstuck}/> Use Hardstuck API?
		<span class="help-tip"><p>Use the <a href='https://gw2-api.hardstuck.gg/ui'>Hardstuck</a> API to populate container contents</p></span>
		<br/>
		<input id="disable_req" type="checkbox" bind:checked={searchOptions.disableRequire}> Disable requires?
		<input id="disable_set" type="checkbox" bind:checked={searchOptions.disableSet}> Disable set?
		<br/>
		"| set = " <input id="set" type="text" bind:value={searchOptions.customSet}> "| requires = " <input id="release" type="text" size=4 bind:value={searchOptions.customRequire}> "| salvage = " <input id="salvage" type="text" size=8 bind:value={searchOptions.customSalvage}>
		<button type="button" on:click={searchCache}>Submit</button>
	</form>
</div>

<style>
	form {
		text-align: center;
	}
	#search {
		font-size: 150%;
		width: 15em;
	}
	.help-tip{
		text-align: center !important;
		background-color: #BCDBEA;
		border-radius: 50%;
		width: 24px;
		height: 24px;
		font-size: 14px;
		line-height: 26px;
		cursor: default;
		display: inline-block;
	}

	.help-tip:before{
		content:'?';
		font-weight: bold;
		color:#fff;
	}

	.help-tip:hover p{
		display:inline-block;
	}

	.help-tip p{    /* The tooltip */
		display: none;
		text-align: left;
		background-color: #1E2021;
		padding: 8px;
		position: absolute;
		border-radius: 3px;
		box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
		color: #FFF;
		font-size: 13px;
		line-height: 1.4;
	}

	

	.help-tip p:after{ /* Prevents the tooltip from being hidden */
		width:100%;
		height:40px;
		content:'';
		position: absolute;
		top:-40px;
		left:0;
	}
</style>

